const webCamLoader = {
    _webCamNodes: [],
    _intervals: [],

    init() {
        let self = this;
        if(document.querySelectorAll('.js-webcam').length > 0) {
            self._fireInTheHole();
        }
    },

    _fireInTheHole() {
        let self = this;
        self._webCamNodes = document.querySelectorAll('.js-webcam');

        self._webCamNodes.forEach((webcam, index) => {
            self._renderImage(webcam, index);
        });
    },

    _renderImage(webcam, index) {
        let self = this;
        let img = null;

        if(! webcam.querySelector('img')) {
            self._createPhoto(webcam);
        }

        if(webcam.dataset.type === 'radnice') {
            let timeout = 65 * 1000;
            let now = new Date().getSeconds()
        
            window.setTimeout(() => {
                self._updatePhoto(webcam);
                self._intervals[index] = window.setInterval(() => {
                    self._updatePhoto(webcam);
                }, timeout);
            }, (65 - now) * 1000);
        }
      
        if(webcam.dataset.type === 'stadion') {
            let timeout = 35 * 1000;
            let now = new Date().getSeconds()
        
            window.setTimeout(() => {
                self._updatePhoto(webcam);
                self._intervals[index] = window.setInterval(() => {
                    self._updatePhoto(webcam);
                }, timeout);

            }, (now > 35 ? 65 - now : 35 - now) * 1000);
        }
    },

    _updatePhoto(webcam) {
        let self = this;    
        self._createPhoto(webcam, true);
    },

    _createPhoto(webcam, hidden) {
        let self = this;
        let img = document.createElement('img');
        img.classList.add('no-resize');
        
        webcam.appendChild(img);

        if(webcam.dataset.type === 'radnice') {
            img.src = 'https://www.mestokyjov.cz/ftp-webcam/radnice.jpg?T' + new Date().getTime();
        }
      
        if(webcam.dataset.type === 'stadion') {
            let directory = new Date();
            directory = directory.toJSON().split('T')[0];
            img.src = 'https://www.mestokyjov.cz/ftp-webcam/' + directory + '/stadion.jpg?T' + new Date().getTime();    
        }

        if(hidden) {
            img.classList.add('webcam__img-transition');
            window.setTimeout(() => {
                img.classList.add('webcam__img-transition--reveal');
            }, 1);
        
            window.setTimeout(() => {
                webcam.querySelectorAll('img')[0].remove();
                img.classList.remove('webcam__img-transition');
                img.classList.remove('webcam__img-transition--reveal');
            }, 1001);
        }
    },

    destroy() {
        let self = this;

        if(self._intervals.length > 0) {
            self._intervals.forEach(interval => {
                window.clearInterval(interval);
            });

            self._intervals = [];
            self._webCamNodes = null;
        }

        self.init();
    }
};

window.webCamLoader = webCamLoader;
window.webCamLoader.init();

document.addEventListener('LokiRequestEnd', function () {
    window.webCamLoader.destroy();
});